<script setup lang="ts">
import { useGlobalStore } from '~/stores/global';

defineProps(['text-size'])

const { navigationLinks } = useGlobalStore()

const hoverClasses: Record<string, string> = {
  Blue: 'hover:text-blue-500 hover:[text-shadow_0_0_5px_var(--color-blue-500)]',
  Red: 'hover:text-red-500 hover:[text-shadow_0_0_5px_var(--color-red-500)]',
  Orange: 'hover:text-orange-500 hover:[text-shadow_0_0_5px_var(--color-orange-500)]',
  Green:  'hover:text-green-500 hover:[text-shadow_0_0_5px_var(--color-green-500)]',
  Purple: 'hover:text-purple-500 hover:[text-shadow_0_0_5px_var(--color-purple-500)]',
};

const activeClasses: Record<string, string> = {
  Blue: 'text-blue-500 [text-shadow:_0_0_20px_var(--color-blue-500)] opacity-100!',
  Red: 'text-red-500 [text-shadow:_0_0_20px_var(--color-red-500)] opacity-100!',
  Orange: 'text-orange-500 [text-shadow:_0_0_20px_var(--color-orange-500)] opacity-100!',
  Green: 'text-green-500 [text-shadow:_0_0_20px_var(--color-green-500)] opacity-100!',
  Purple: 'text-purple-500 [text-shadow:_0_0_20px_var(--color-purple-500)] opacity-100!',
};

</script>

<template>
  <NuxtLink
    v-for="{ name, to, color } in navigationLinks"
    class="tracking-widest opacity-70 hover:opacity-100 my-2 transition-all hover:cursor-pointer"
    :class="`${hoverClasses[color]} ${textSize}`"
    :active-class="activeClasses[color]"
    :to="{ name: to }"
  >
    {{ name }}
  </NuxtLink>

  <NuxtLink
    class="tracking-widest opacity-70 hover:opacity-100 my-2 transition-all hover:cursor-pointer"
    :class="`${hoverClasses['Orange']} ${textSize}`"
    onclick="contactModal.showModal()"
    to=""
  >
    Contact
  </NuxtLink>
</template>
